import "../stylesheets/bootstrap/page/group_insurances"
import flatpickr from "flatpickr"
import moment from "moment"
import "../controllers/nested_form"

// 公告
$(function () {
  //open popup
  if ($('#link-first-notice').length > 0) {
    setTimeout(function () {
      $('#link-first-notice').click();
    }, 1000)
  }

})



//// 日期設定
$(function () {
  //預設出發時間  現在時間往後一個小時的整點
  var defaultStartDate = getStartDate().add(1, 'hour').startOf('hour')
  console.log(defaultStartDate.date())

  //預設回程時間  現在時間往後五天又一個小時的整點
  var defaultEndDate = getStartDate().add(5, 'days').add(1, 'hour').startOf('hour')
  let dateStart = flatpickr('#group_insurance_insured_from', {
    enableTime: true,
    dateFormat: "Y/m/d H:i",
    minDate: defaultStartDate.toDate(),
    defaultDate: defaultStartDate.toDate(),
    maxDate: defaultStartDate.clone().add(60, 'days').toDate(),
    minuteIncrement: 60,
    onChange: function (selectedDates, dateStr, instance) {

      let end = dateEnd
      //如果出發日選得比返程日還大
      var endDate = end.selectedDates[0].setSeconds(0);
      if (endDate <= selectedDates[0]) {
        //將出發日＋1天設定回返程日
        endDate = setTime(new Date(selectedDates[0]), 1, 0, 0)
        end.setDate(endDate);
        console.log('change', selectedDates);
      }
      duration()
    }
  });

  let dateEnd = flatpickr('#group_insurance_insured_till', {
    enableTime: true,
    dateFormat: "Y/m/d H:i",
    minDate: defaultStartDate.clone().add(1, 'days').toDate(),
    defaultDate: defaultEndDate.toDate(),
    minuteIncrement: 60,
    onChange: function (selectedDates, dateStr, instance) {

      console.log('trigger: end', dateStr)
      let start = dateStart
      //如果返程日選得比出發日還小
      var startDate = start.selectedDates[0];
      if (startDate >= selectedDates[0]) {
        //將出發日＋1天設定回返程日
        startDate = setTime(new Date(selectedDates[0]), -1, 0, 0)
        start.setDate(startDate);
        console.log('change', selectedDates);
      }
      duration()
    }
  });

  function duration() {
    var duration = Math.ceil((dateEnd.selectedDates[0] - dateStart.selectedDates[0]) / 86400000)
    $('#duration').text(duration)
  }

  function setTime(time, day, hour, min) {
    time.setDate(time.getDate() + day)
    time.setHours(time.getHours() + hour)
    time.setMinutes(min)
    return time
  }

  function getStartDate() {
    const date = moment()
    switch (date.weekday()) {
      case 0:
      case 1:
      case 2:
        return date.add(3, 'days')
      case 3:
      case 4:
      case 5:
        return date.add(5, 'days')
      case 6:
        return date.add(4, 'days')
    }
  }
})

//// 表單控制
$(function () {
  var option = '<option value="1">本人</option>';
  var isClick = true
  //驗證國家跟成員有沒有寫
  $('.form').validate({
    onfocusout: function (element) {
      return $(element).valid();
    },
    onchange: function (element) {
      return $(element).valid();
    },
    submitHandler: function (form) {
      var validate = true


      if ($(form).find('.group-list > .fields').length == 0) {
        $('.error-alarm').append('<div class="alert alert-danger" role="alert"><i class="icon-remove-sign"></i>至少要有一位被保險人<button type="button" class="close" data-dismiss="alert" aria-hidden="true">×</button></div>')

        validate = false
      }
      if ($(form).find('.countries_list > .fields').length == 0) {

        $('.error-alarm').append('<div class="alert alert-danger" role="alert"><i class="icon-remove-sign"></i>請輸入至少一個國家<button type="button" class="close" data-dismiss="alert" aria-hidden="true">×</button></div>')

        validate = false
      }
      if (validate) {
        if (isClick) {
          isClick = false
          form.submit()
        }
      } else {
        $('html').scrollTop(0)
      }
    }
  })

  //洲別更動
  $(document).on('change', '.continent_id', function () {
    let element = $(this).parent().find('.country_id')
    let continent_id = $(this).val()
    element.empty()

    fetch(`/api/v2/countries/get_options_by_content/${continent_id}`).then(res => res.json())
      .then(res => {
        console.log(res)
        res.countries.forEach((country) => {
          option = $('<option></option>').attr("value", country[1]).text(country[0]);
          element.append(option)
        })
      })
  })

  $(document).on('change', '.relationship', function () {

    // 如果 關係 選擇『本人』
    if ($(this).val() == 1) {
      $($(this).parent().find('.name')).val($('#group_insurance_name').val())
      $($(this).parent().find('.name')).attr("readonly", "readonly");
    }
    else {
      $($(this).parent().find('.name')).removeAttr("readonly");
    }
  })

  $(document).on('change', '#group_insurance_name', function () {
    $_this = $(this)
    $('.relationship').each(function () {
      if ($(this).val() == 1) {
        $($(this).parent().find('.name')).val($_this.val())
        $($(this).parents('.list').find('.title')).text($_this.val())

      }
    })
  })

  $('.addform-area-fake').on("click", function () {
    $('.addform-area-real').click();
  })

  $('.addform-members-fake').on("click", function () {
    $('.addform-members-real').click();
    document.querySelector('.birthday').onkeypress = function (e) {
      if (isNaN(String.fromCharCode(event.which))) {
        e.preventDefault()
      } else if (this.value.length == 5) {
        if (parseInt(String.fromCharCode(event.which)) > 1) {
          e.preventDefault()
          this.value += "0" + String.fromCharCode(event.which)
        }
      } else if (this.value.length == 8) {
        if (parseInt(String.fromCharCode(event.which)) > 3) {
          e.preventDefault()
          this.value += "0" + String.fromCharCode(event.which)
        }
      }

    };


    document.querySelector('.birthday').onkeyup = function (e) {
      if (event.keyCode != 8) {
        if (this.value.length == 4) {
          this.value += '/';
        }
        if (this.value.length == 7) {
          this.value += '/';
        }
      }
    };
    $(".datepicker").each(function () {
      if ($(this).val() == '') {
        $(this).flatpickr({
          dateFormat: "Y/m/d",
          maxDate: "today",
          defaultDate: "1990/01/01"
        });
      }
    });
  })

  //完成選擇
  function selected($list, title) {
    console.log($list)
    //隱藏選單
    $list.find('.select-box').addClass('d-none');
    //把名稱放上去
    $list.find('p.title').text(title);
    $list.addClass('selected');
    $list.find('.control .remove').remove();

  }

  function validate($list) {
    if (!$list.find('select').valid())
      return false
    if (!$list.find('input').valid())
      return false
    return true


  }

  //確認國家
  $(document).on('click', '.country-confirm', function () {
    console.log('move')
    var list = $(this).parent().parent().parent()
    var countryId = $(list).find('.country_id').val()
    var countryName = $(list).find('.country_id').find('[value=' + countryId + ']').text()

    if (validate($(list)))
      selected($(list), countryName);

  })

  //確認組員
  $(document).on('click', '.member-confirm', function () {

    var list = $(this).parent().parent().parent()
    var name = $(list).find('.name').val()
    if (validate($(list)))
      selected($(list), name);

  })

  //編輯
  $(document).on('click', '.list.selected', function () {
    //設定本人要不要出現
    if ($(this).find('.relationship').val() != 1) {
      if (hasSelf()) {
        $(this).find('.relationship').find('[value = 1]').remove();
      } else if ($(this).find('.relationship').find('[value = 1]').length == 0) {
        $(this).find('.relationship').append(option);
      }
    }
    //顯示控制面板
    $(this).find('.select-box').removeClass('d-none');
    $(this).removeClass('selected');
  })

  //如果是本人 預設顯示
  $(document).on('change', '.relationship', function () {
    console.log($(this))
    console.log($('#group_insurance_name').text())
    if ($(this).val() == 1) {
      $($(this).parent().find('.name')).val($('#group_insurance_name').val())
    }

  })


  //是否有輸入過本人
  function hasSelf() {
    var has_self
    $('.relationship').each(function () {
      console.log('relation:', $(this).val(), $(this).val() == 1)

      if ($(this).val() == 1)
        has_self = true
    })
    if (has_self)
      return true
    else
      return false
  }

  //新增時檢查是否為本人選項有沒有被輸入
  $(document).on('nested:fieldAdded', function (event) {
    var field = event.field;
    console.log('0', $(field))
    if ($(field).has('.relationship').length > 0) {
      //console.log('1',hasSelf())
      if (hasSelf()) {
        console.log('2')
        $(field).find('.relationship').find('[value = 1]').remove();
      } else if ($(field).find('.relationship').find('[value = 1]').length == 0) {
        $(field).find('.relationship').append(option)
      }
    }
  })
})



console.log("group_insurance.js")